module.exports = __webpack_public_path__ + "static/img/rbs.13392425.svg";